export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGIN_RESET = 'USER_LOGIN_RESET';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';
export const USER_REGISTER_RESET = 'USER_REGISTER_RESET';

export const USER_CONSENT_REQUEST = 'USER_CONSENT_REQUEST';
export const USER_CONSENT_SUCCESS = 'USER_CONSENT_SUCCESS';
export const USER_CONSENT_FAIL = 'USER_CONSENT_FAIL';

export const USER_REMOVE_ACCESS_REQUEST = 'USER_REMOVE_ACCESS_REQUEST';
export const USER_REMOVE_ACCESS_SUCCESS = 'USER_REMOVE_ACCESS_SUCCESS';
export const USER_REMOVE_ACCESS_FAIL = 'USER_REMOVE_ACCESS_FAIL';

export const USER_NOTIFICATIONS_REQUEST = 'USER_NOTIFICATIONS_REQUEST';
export const USER_NOTIFICATIONS_SUCCESS = 'USER_NOTIFICATIONS_SUCCESS';
export const USER_NOTIFICATIONS_FAIL = 'USER_NOTIFICATIONS_FAIL';

export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST';
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS';
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL';
export const USER_DETAILS_RESET = 'USER_DETAILS_RESET';

export const USER_SEARCH_REQUEST = 'USER_SEARCH_REQUEST';
export const USER_SEARCH_SUCCESS = 'USER_SEARCH_SUCCESS';
export const USER_SEARCH_FAIL = 'USER_SEARCH_FAIL';

export const USER_CREATE_CONSULTATION_REQUEST = 'USER_CREATE_CONSULTATION_REQUEST';
export const USER_CREATE_CONSULTATION_SUCCESS = 'USER_CREATE_CONSULTATION_SUCCESS';
export const USER_CREATE_CONSULTATION_FAIL = 'USER_CREATE_CONSULTATION_FAIL';
export const USER_CREATE_CONSULTATION_RESET = 'USER_CREATE_CONSULTATION_RESET';
